export function getCapacityPercentage(itemCapacity) {
    let availableTime = itemCapacity.available - itemCapacity.absence;
    let workedTime = itemCapacity.planned;
    let planned = ((workedTime / availableTime) * 100).toFixed(2);
    if (isNaN(planned)) {
        return '';
    }
    return parseFloat(planned).toFixed(2);
}
